import { render, staticRenderFns } from "./ScrollProgression.vue?vue&type=template&id=477336c6&scoped=true&"
import script from "./ScrollProgression.vue?vue&type=script&lang=js&"
export * from "./ScrollProgression.vue?vue&type=script&lang=js&"
import style0 from "./ScrollProgression.vue?vue&type=style&index=0&id=477336c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477336c6",
  null
  
)

export default component.exports